import Loader from "../../DomUtilities/Loader";
import openErrorModal from "../../Error/ErrorModal";
import { fetchOrderOverviewModal} from "../../HTTPRequests/OrderRequests";
import OrderPrintHandler from "../OrderPrintHandler";
import OrderOverviewModalsHandler from "./OrderOverviewModalsHandler";

export default class OrderOverviewModal {
	modalDiv: HTMLDivElement;
	orderStatusLogModal: HTMLDivElement;
	isInfoModalOpen: boolean;
	id: string;
	orderOverviewModalsHandler: OrderOverviewModalsHandler;

	constructor() {
		this.modalDiv = document.createElement("div");
		this.isInfoModalOpen = false;
		this.modalDiv.id = "order-overview";
	}

	public init(row: HTMLTableRowElement) {
		row.onclick = () => {
			this.fetchOverviewModal(row.id);
		}
	}

	public fetchOverviewModal(id) {
		Loader.show();
		this.id = id;
		fetchOrderOverviewModal(id)
			.then((response: string) => {
				this.openOverviewModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private openOverviewModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);
		this.addModalClickListeners();
		this.orderOverviewModalsHandler = new OrderOverviewModalsHandler(this.id, this.modalDiv);
	}

	private addModalClickListeners() {
		const closeImg: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		closeImg.onclick = () => {
			this.orderOverviewModalsHandler.orderStatusLogModal = null;
			this.modalDiv.remove();
		}

		this.modalDiv.onclick = (event) => {
			if (!this.orderOverviewModalsHandler.isInfoModalOpen && event.target === this.modalDiv.firstElementChild) {
				this.orderOverviewModalsHandler.orderStatusLogModal = null;
				this.modalDiv.remove();
			}
		}

		const printButton: HTMLButtonElement = this.modalDiv.querySelector('.print-btn');
		printButton.onclick = () => {
			new OrderPrintHandler(this.id, null);
		}
	}
}
